<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="row mb-3">
          <div class="col-lg-12">
            <v-expansion-panels flat popout hover>
              <v-expansion-panel
              >
                <v-expansion-panel-header class="bg-light">
                  <span><v-icon left>mdi-magnify</v-icon>Detaylı Arama</span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="container-xxl-fluid">
                    <div class="row">
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeStart)"
                                label="Tarih Aralık Başlangıç"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeStart = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeStart"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <v-menu
                            transition="scale-transition"
                            offset-y
                            :close-on-content-click="false"
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                :value="formattedDate(dateRangeEnd)"
                                label="Tarih Aralık Bitiş"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                filled
                                solo
                                dense
                                clearable
                                @click:clear="dateRangeEnd = null"
                                v-bind="attrs"
                                v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="dateRangeEnd"
                              locale="tr"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                      <div class="col-lg-3">
                        <search-select
                            :search-type="'current'"
                            @itemChange="(e) => (selectedCurrent = e)"
                            :label="'Cari'"
                        >
                        </search-select>
                      </div>
                      <div class="col-lg-3">
                        <search-select
                            :search-type="'stock'"
                            @itemChange="(e) => (selectedStock = e)"
                            :label="'Stok'"
                        >
                        </search-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="groupCodeValue"
                            label="Grup Kodu"
                            :items="groupCodeList"
                            item-text="name"
                            item-value="code"
                            filled
                            solo
                            dense
                            clearable
                            multiple
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="groupCodeValue1"
                            label="Kod 1"
                            :items="groupCodeList1"
                            item-text="name"
                            item-value="code"
                            filled
                            solo
                            dense
                            clearable
                            multiple
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="groupCodeValue2"
                            label="Kod 2"
                            :items="groupCodeList2"
                            item-text="name"
                            item-value="code"
                            filled
                            solo
                            dense
                            clearable
                            multiple
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="groupCodeValue3"
                            label="Kod 3"
                            :items="groupCodeList3"
                            item-text="name"
                            item-value="code"
                            filled
                            solo
                            dense
                            clearable
                            multiple
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="groupCodeValue4"
                            label="Kod 4"
                            :items="groupCodeList4"
                            item-text="name"
                            item-value="code"
                            filled
                            solo
                            dense
                            clearable
                            multiple
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="groupCodeValue5"
                            label="Kod 5"
                            :items="groupCodeList5"
                            item-text="name"
                            item-value="code"
                            filled
                            solo
                            dense
                            clearable
                            multiple
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-select
                            v-model="salesPersonCode"
                            label="Plasiyer"
                            filled
                            solo
                            dense
                            clearable
                            :items="salesPersonList"
                            :item-text="item => item.name"
                            :item-value="item => item.code"
                        >

                        </v-select>
                      </div>
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="documentNumber"
                            label="Sipariş No"
                            filled
                            solo
                            dense
                            clearable
                        >

                        </v-text-field>
                      </div>
                      <div class="col-lg-3">
                        <v-text-field
                            v-model="producerCode"
                            label="Üretici Kodu"
                            filled
                            solo
                            dense
                            clearable
                        >

                        </v-text-field>
                      </div>
                      <div class="col-lg-12 text-end">
                        <v-btn
                            color="primary darken-1"
                            small
                            @click="_fetchPendingOrders"
                        >
                          <v-icon left>mdi-magnify</v-icon>
                          Filtrele
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <div class="col-lg-12 d-flex flex-wrap">
            <div>
              <p class="text-center">Gösterilen Kayıt Sayısı</p>
              <v-btn-toggle mandatory solo dense>
                <v-btn @click="perPage = 10"> 10</v-btn>
                <v-btn @click="perPage = 20"> 20</v-btn>
                <v-btn @click="perPage = 30"> 30</v-btn>
                <v-btn @click="perPage = 50"> 50</v-btn>
                <v-btn @click="perPage = 100"> 100</v-btn>
              </v-btn-toggle>
            </div>
          </div>
        </div>
        <div class="row">
          <p class="text-start">Toplam <b>{{ pendingOrdersMetaData.totalCount ?? 0 }}</b> Kayıt Bulundu</p>
          <ResultTableView v-bind="dynamicProps"></ResultTableView>
        </div>
        <!-- end row -->

        <div class="row">
          <div class="col-lg-12 mb-5">
            <v-pagination
                v-model="currentPage"
                class="my-4"
                :length="pendingOrdersMetaData.totalPages"
                :total-visible="8"
            ></v-pagination>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import ResultTableView from "@/components/orders/PurchaseOrders/dialogs/PurchaseOrderResult/ResultsTableView";
import {formattedDate} from "@/momentHelper";
import {mapState, mapActions} from "vuex";
import SearchSelect from "@/components/searchSelect.vue";

export default {
  components: {
    SearchSelect,
    ResultTableView
  },
  props: {
    listType: {
      type: String,
      default: "SiparisList"
    }
  },
  mounted() {
    this._fetchStockCodes();
    this.fetchSalesPersonList({
      params: {},
      body: {}
    });
    this._fetchPendingOrders()
  },
  computed: {
    ...mapState("order", ["pendingOrders", "pendingOrdersHeaders", "pendingOrdersLoading","pendingOrdersMetaData"]),
    ...mapState("auth", ["user"]),
    ...mapState("current", ["salesPersonList"]),
    dynamicProps: function() {
      return { perPage: this.perPage, currentPage: this.currentPage };
    }
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      dateRangeStart: null,
      dateRangeEnd: null,
      selectedCurrent: null,
      currentSearchText: null,
      searchCurrentLoading: false,
      currentSearchResult: [],
      searchCurrentTimeout: null,
      stockSearchResult: [],
      searchStockTimeout: null,
      selectedStock: null,
      stockSearchText: "",
      searchStockLoading: false,
      searchText: null,
      statusValue: null,
      salesPersonCode: null,
      groupCodeList:[],
      groupCodeList1:[],
      groupCodeList2:[],
      groupCodeList3:[],
      groupCodeList4:[],
      groupCodeList5:[],
      groupCodeValue:null,
      groupCodeValue1:null,
      groupCodeValue2:null,
      groupCodeValue3:null,
      groupCodeValue4:null,
      groupCodeValue5:null,
      cityValue: null,
      townValue: null,
      documentNumber: null,
      producerCode: null,

    };
  },
  methods: {
    formattedDate,
    ...mapActions("order", ["fetchPendingOrders"]),
    ...mapActions("stock", ["fetchStockList","fetchStockCodes"]),
    ...mapActions("current", ["fetchSalesPersonList", "fetchCurrentList"]),
    async _fetchStockCodes(){
      let codeList = [1,2,3,4,5,6];
      for (let i = 0; i < codeList.length; i++) {
        let requestParams = {};
        requestParams.params = {tableType: codeList[i]};
        requestParams.body = {}
        let result = await this.fetchStockCodes(requestParams);
        switch (codeList[i]){
          case 1:
            this.groupCodeList = result;
            break;
          case 2:
            this.groupCodeList1 = result;
            break;
          case 3:
            this.groupCodeList2 = result;
            break;
          case 4:
            this.groupCodeList3 = result;
            break;
          case 5:
            this.groupCodeList4 = result;
            break;
          case 6:
            this.groupCodeList5 = result;
            break;

        }
      }
    },
    async _fetchCurrentList() {
      this.currentSearchResult = [];
      this.currentSearchResult = await this.fetchCurrentList({
        params: {
          userId: this.user.UserId,
          pageNumber: 1,
          pageSize: this.perPage,
          ...(this.user.RoleGroupId == "2" || this.user.RoleGroupId == 2  ? true : false) && {salesPersonCode: this.user.SalesPersonCode },
          ...(!(this.currentSearchText === "" || this.currentSearchText == null)) && {searchText: this.currentSearchText}
        },
        body: {},
        onlyData: true,
        loading: false
      });
      this.searchCurrentLoading = false

    },
    async _fetchStockList() {
      this.stockSearchResult = await this.fetchStockList({
        params: {
          pageNumber: 1,
          pageSize: this.perPage,
          userId: this.user.UserId,
        },
        body: {
          stock: this.stockSearchText,
          GenericCategories: null
        },
        onlyData: true,
        loading: false
      });
      this.searchStockLoading = false

    },
    async _fetchPendingOrders() {
      // let body = {
      //       ...(!(this.dateRangeStart === "" || this.dateRangeStart == null)) && {date1: this.dateRangeStart},
      //       ...(!(this.dateRangeEnd === "" || this.dateRangeEnd == null)) && {date2: this.dateRangeEnd},
      //       ...(!(this.selectedStock === "" || this.selectedStock == null)) && {stock: this.selectedStock},
      //       ...(!(this.selectedCurrent === "" || this.selectedCurrent == null)) && {current: this.selectedCurrent},
      //       ...(!(this.groupCodeValue === "" || this.groupCodeValue == null)) && {groupCode: this.groupCodeValue},
      //       ...(!(this.groupCodeValue1 === "" || this.groupCodeValue1 == null)) && {code1: this.groupCodeValue1},
      //       ...(!(this.groupCodeValue2 === "" || this.groupCodeValue2 == null)) && {code2: this.groupCodeValue2},
      //       ...(!(this.groupCodeValue3 === "" || this.groupCodeValue3 == null)) && {code3: this.groupCodeValue3},
      //       ...(!(this.groupCodeValue4 === "" || this.groupCodeValue4 == null)) && {code4: this.groupCodeValue4},
      //       ...(!(this.groupCodeValue5 === "" || this.groupCodeValue5 == null)) && {code5: this.groupCodeValue5},
      //       ...(!(this.documentNumber === "" || this.documentNumber == null)) && {documentNumber: this.documentNumber},
      //       ...(!(this.salesPersonCode === "" || this.salesPersonCode == null)) && {salesPersonCode: this.salesPersonCode}
      //     }
      await this.fetchPendingOrders({
        params: {
          pageNumber: this.currentPage,
          pageSize: this.perPage
        },
        body: {
          ...(!(this.dateRangeStart === "" || this.dateRangeStart == null)) && {date1: this.dateRangeStart},
          ...(!(this.dateRangeEnd === "" || this.dateRangeEnd == null)) && {date2: this.dateRangeEnd},
          ...(!(this.selectedStock === "" || this.selectedStock == null)) && {stock: this.selectedStock},
          ...(!(this.selectedCurrent === "" || this.selectedCurrent == null)) && {current: this.selectedCurrent},
          ...(!(this.groupCodeValue?.length <= 0)) && {groupCode: this.groupCodeValue},
          ...(!(this.groupCodeValue1?.length <= 0)) && {code1: this.groupCodeValue1},
          ...(!(this.groupCodeValue2?.length <= 0)) && {code2: this.groupCodeValue2},
          ...(!(this.groupCodeValue3?.length <= 0)) && {code3: this.groupCodeValue3},
          ...(!(this.groupCodeValue4?.length <= 0)) && {code4: this.groupCodeValue4},
          ...(!(this.groupCodeValue5?.length <= 0)) && {code5: this.groupCodeValue5},
          ...(!(this.documentNumber === "" || this.documentNumber == null)) && {documentNumber: this.documentNumber},
          ...(!(this.salesPersonCode === "" || this.salesPersonCode == null)) && {salesPersonCode: this.salesPersonCode},
          ...(!(this.producerCode === "" || this.producerCode == null)) && {producerCode: this.producerCode}
        }
      })
    }
  },
  watch: {
    stockSearchText: function (newVal) {
      if (newVal && (newVal.length > 2)) {
        this.stockSearchResult = [];
        if (this.searchStockTimeout)
          clearTimeout(this.searchStockTimeout);
        this.searchStockLoading = true
        this.searchStockTimeout = setTimeout(() => {

          this._fetchStockList();

        }, 2000);
      }
    },
    currentSearchText: function (newVal) {
      if (newVal && (newVal.length > 2)) {
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
        this.searchCurrentLoading = true
        this.currentSearchResult = [];
        this.searchCurrentTimeout = setTimeout(() => {

          this._fetchCurrentList();
        }, 1500);
      } else {
        this.searchCurrentLoading = false;
        if (this.searchCurrentTimeout)
          clearTimeout(this.searchCurrentTimeout);
      }
    },
    perPage: function (newVal) {
      newVal;
      this.perPage = newVal;
      this._fetchPendingOrders();
    },

    currentPage: function (newVal) {
      newVal;
      this.currentPage = newVal
      this._fetchPendingOrders();
    },
  }
};
</script>